import Application from './application';

export default class InitiativeAdapter extends Application {
  async findAllInitiativesDataset() {
    var url = `${this.host}/initiatives`;
    let res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/x.dataset+json',
        ...this.headers,
      },
    });
    if (res.status === 200) {
      const data = res.json();
      return data;
    } else {
      return false;
    }
  }

  async findInitiativesForRoadmapDataset(roadmap) {
    if (roadmap == undefined) return false;
    const initiatives = await roadmap.initiatives?.content;
    const initiative_ids = initiatives.map((i) => i.id).join(',');
    var url = `${this.host}/initiatives?filter[ids]=${initiative_ids}`;

    let res = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/x.dataset+json',
        ...this.headers,
      },
    });
    if (res.status === 200) {
      const data = await res.json();
      return data;
    } else {
      return false;
    }
  }
}
